"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactSalesButtonPropsInterface = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var ContactSalesButtonPropsInterface = {
  allowModal: _propTypes.default.bool,
  contactIsc: _propTypes.default.bool,
  termId: _propTypes.default.number,
  additionalUnitQuantity: _propTypes.default.number
};
exports.ContactSalesButtonPropsInterface = ContactSalesButtonPropsInterface;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/contactSales/ContactSalesPropsInterface.js
// module id = 442
// module chunks = 5 6